export const ADMIN = 'admin';
export const USER_BASIC = 'user-basic';
export const USER_TEST = 'user-test';
export const USER_PAID = 'user-paid';
export const USER_ENTERPRISE = 'user-enterprise';
export const GUEST = 'guest';
